import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Button,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ScenarioRow from "./ScenarioRow";

export default function FlowAccordion({
  flow,
  selection,
  onSelectionChange,
  scenarioStatuses,
  selectedDevice,
}) {
  const selectable = flow.scenarios.filter(
    (s) => !["running", "queued"].includes(scenarioStatuses[s.id]),
  );

  const allSelectableSelected =
    selectable.length > 0 && selectable.every((s) => selection.includes(s.id));

  const toggleAll = (e) => {
    e.stopPropagation();
    if (allSelectableSelected) {
      onSelectionChange([]);
    } else {
      onSelectionChange(selectable.map((s) => s.id));
    }
  };

  return (
    <Accordion sx={{ mb: 1, ":before": { display: "none" } }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box display="flex" justifyContent="space-between" width="100%" pr={2}>
          <Box display="flex" gap={2} alignItems="center">
            <Typography variant="h6">{flow.name}</Typography>
            <Chip label={`${flow.scenarios.length} scenarios`} size="small" />
            {selection.length > 0 && (
              <Chip
                label={`${selection.length} selected`}
                size="small"
                color="primary"
                variant="outlined"
              />
            )}
          </Box>

          <Button
            size="small"
            variant="outlined"
            onClick={toggleAll}
            disabled={selectable.length === 0}
          >
            {allSelectableSelected ? "Deselect All" : "Select All"}
          </Button>
        </Box>
      </AccordionSummary>

      <AccordionDetails>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox" width={50} />
                <TableCell width={160}>ID</TableCell>
                <TableCell>Title</TableCell>
                <TableCell width={120} align="right">
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {flow.scenarios.map((scenario) => (
                <ScenarioRow
                  key={scenario.id}
                  scenario={scenario}
                  flowId={flow.id}
                  checked={selection.includes(scenario.id)}
                  onToggle={() =>
                    onSelectionChange(
                      selection.includes(scenario.id)
                        ? selection.filter((id) => id !== scenario.id)
                        : [...selection, scenario.id],
                    )
                  }
                  runStatus={scenarioStatuses[scenario.id]}
                  selectedDevice={selectedDevice}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </AccordionDetails>
    </Accordion>
  );
}
